import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import type { AgentApiCandidateEndpointsCopySourceCandidate } from '@/types/serializers';

export type CopySourceCandidatesQuery = {
  keyword?: string;
  assignee_id?: number;
  candidate_profile_id?: number;
};

type Response = {
  records: AgentApiCandidateEndpointsCopySourceCandidate[];
};

export default function useCopySourceCandidates(query: CopySourceCandidatesQuery) {
  return useQuery({
    queryKey: ['/agent/api/candidate_endpoints/copy_source_candidates', query],
    retry: false,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const q = qs.stringify(query, { arrayFormat: 'brackets', skipNulls: true });
      const response = await fetch(
        `/agent/api/candidate_endpoints/copy_source_candidates.json?${q}`
      );
      if (!response.ok) {
        throw new Error('Failed to fetch copy source candidates');
      }
      const data: Response = await response.json();
      return data;
    },
  });
}
